import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';
import { Link } from 'react-router-dom';
import './About.css';

// Import images
import academyLogo from '../assets/images/ProgenX Akademi.png';
import hakkindaHeroImage from '../assets/images/hakkinda.jpg';
import kalkinma from '../assets/images/kalkinma.png';
import ankaraKalkinma from '../assets/images/ankaraka-logo.png';
import aws from '../assets/images/aws.png';
import timteb from '../assets/images/timteb.jpg';
import googleforstartups from '../assets/images/googleforstartups.png';
import microsoftforstartups from '../assets/images/microsoftforstartups.png';
import nvidiaInception from '../assets/images/nvidia-inception-logo.png';
import etkimlogodct from '../assets/images/etkimlogodct.png';
import claudePartnerNetwork from '../assets/images/claude-partner-network.png';

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>ProgenX Hakkında | Eğitim ve Bilişim Teknolojileri Şirketi 2025</title>
        <meta name="description" content="ProgenX, TÜBİTAK BİGG fonu ile kurulmuş, eğitimde dijital dönüşümü hızlandıran ve yenilikçi teknolojilerle öğrenme deneyimini dönüştüren bir teknoloji şirketidir. ODTÜ Teknokent'te faaliyet gösteren, AWS Activate üyesi ve Teknogirişim Rozeti sahibi şirketimizin vizyonu, misyonu ve hizmetleri hakkında bilgi edinin." />
        <meta name="keywords" content="progenx hakkında, progenx vizyonu, progenx misyonu, eğitimde dijital dönüşüm, yapay zeka eğitim, tübitak bigg, odtü teknokent, aws activate, teknogirişim rozeti, etkim meb" />
        <meta property="og:title" content="ProgenX Hakkında | Eğitim ve Bilişim Teknolojileri" />
        <meta property="og:description" content="TÜBİTAK BİGG fonu ile kurulmuş, eğitimde dijital dönüşümü hızlandıran teknoloji şirketi." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/hakkinda" />
        <link rel="canonical" href="https://progenxacademy.com/hakkinda" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.",
            "url": "https://progenxacademy.com",
            "logo": "https://progenxacademy.com/logo.png",
            "description": "Eğitim teknolojileri alanında yenilikçi çözümler sunan, yapay zekâ destekli öğrenme platformları geliştiren teknoloji şirketi",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "postalCode": "06800",
              "addressCountry": "TR"
            },
            "foundingDate": "2020",
            "award": "Teknogirişim Rozeti",
            "memberOf": ["AWS Activate", "ETKİM MEB", "TÜBİTAK BİGG", "Claude Partner Network"]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="Hakkımızda" 
        backgroundImage={hakkindaHeroImage}
      />
      
      <section className="about-content">
        <div className="container">
          <div className="about-row">
            <div className="about-text">
              <h2 className="section-title">PROGENX AKADEMİ</h2>
              <div className="about-description">
                <p>
                  ProgenX, eğitim teknolojileri alanında yenilikçi çözümler sunan, yapay zekâ destekli öğrenme platformları geliştiren bir teknoloji şirketidir. 
                  Türkiye Eğitim Teknolojileri Zirvesi'nde (TETZ) yer almış, ETKİM MEB bünyesinde faaliyet gösteren, AWS Activate üyesi olan, 
                  Claude Partner Network'e dahil olan ve 
                  T.C. Sanayi ve Teknoloji Bakanlığı tarafından verilen Teknogirişim Rozeti'ni almaya hak kazanan şirketimiz, 
                  eğitimde dijital dönüşümü destekleyerek öğrencilerin başarı yolculuğunda yanlarında olmayı hedeflemektedir.
                </p>

                <p>
                  Progenx Akademi olarak, eğitimde dijital dönüşümü hızlandıran ve yenilikçi teknolojilerle öğrenme deneyimini dönüştüren bir yaklaşımı benimsiyoruz. Eğitim alanında geliştirdiğimiz akıllı çözümlerle, her çocuğu benzersiz bir birey olarak kabul ediyor ve onlara tamamen kişiselleştirilmiş öğrenme deneyimleri sunuyoruz.
                </p>
                <p>
                TÜBİTAK BİGG fonu ile kurulmuş bir şirket olan Progenx, yalnızca eğitim teknolojileriyle sınırlı kalmıyor; aynı zamanda bilişim ve dijital dönüşüm alanında da geniş bir hizmet yelpazesi sunuyor. Veri bilimi ve yapay zeka çözümlerimiz ile büyük veri setlerinden anlamlı bilgiler çıkarıyor, işletmelerin karar alma süreçlerine güç katıyoruz. Mobil ve web uygulama geliştirme hizmetlerimizle kullanıcı dostu, yüksek performanslı dijital ürünler yaratıyor ve iş süreçlerini dijitalleştiriyoruz.
                </p>
                <p>
                  Progenx, eğitimde fırsat eşitliği sağlamayı ve her öğrencinin bireysel öğrenme ihtiyaçlarına uygun çözümler sunarak akademik başarılarını artırmayı amaçlayan yapay zeka destekli yenilikçi bir platformdur. Amacımız, geleneksel eğitim yöntemlerinin yetersiz kaldığı noktalarda devreye girerek, öğrencilerin bireysel potansiyellerini en üst düzeye çıkarmaktır.
                </p>
                
                <h3>Vizyonumuz</h3>
                <p>
                  Eğitim ve teknoloji alanında dünya çapında yenilikçi çözümler üreterek, bireylerin ve işletmelerin potansiyellerini en üst düzeye çıkaran bir lider olmayı hedefliyoruz. Teknolojiyi, herkesin ulaşabileceği şekilde geliştirerek, toplumda sürdürülebilir dijital dönüşüm süreçlerini hayata geçirmeyi amaçlıyoruz.
                </p>
                
                <h3>Misyonumuz</h3>
                <p>
                  Progenx Akademi olarak, eğitimde kişiselleştirilmiş dijital çözümler sunarak, her öğrencinin benzersiz potansiyelini keşfetmesini sağlıyoruz. Bilişim, yazılım ve dijital dönüşüm çözümleriyle işletmelerin verimliliklerini artırırken, teknolojiye dayalı inovatif projelerle sektördeki en yüksek standartları belirliyoruz.
                </p>

                <div className="about-logos-section">
                  <h4 className="about-logos-heading">Destekleyen</h4>
                  <div className="about-logos-grid about-logos-backed">
                    <div className="about-logo-item">
                      <img src={kalkinma} alt="Türkiye Kalkınma Fonu" />
                    </div>
                    <div className="about-logo-item">
                      <a href="https://www.ankaraka.org.tr" target="_blank" rel="noopener noreferrer">
                        <img src={ankaraKalkinma} alt="Ankara Kalkınma Ajansı" />
                      </a>
                    </div>
                  </div>
                  <h4 className="about-logos-heading">Üye Olduğumuz Programlar</h4>
                  <div className="about-logos-grid about-logos-member">
                    <div className="about-logo-item">
                      <img src={aws} alt="AWS" />
                    </div>
                    <div className="about-logo-item">
                      <img src={timteb} alt="TİMTEB" />
                    </div>
                    <div className="about-logo-item">
                      <img src={googleforstartups} alt="Google for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={microsoftforstartups} alt="Microsoft for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={nvidiaInception} alt="NVIDIA Inception" />
                    </div>
                    <div className="about-logo-item">
                      <img src={etkimlogodct} alt="ETKİM" />
                    </div>
                    <div className="about-logo-item">
                      <img src={claudePartnerNetwork} alt="Claude Partner Network" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="about-image">
              <img src={academyLogo} alt="ProgenX Akademi Logo" />
              <div className="about-quote">
                <p>"Geleceği tahmin etmenin en iyi yolu onu oluşturmaktır."</p>
                <p className="quote-author">-Peter Drucker & Abraham Lincoln</p>
              </div>
              <div className="about-cta">
                <Link to="/progenxakademi" className="btn btn-primary">
                  ŞİMDİ KEŞFEDİN
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Teknolojiyle Geleceğe Adım Atın, İnovasyonun Gücüyle Tanışın!"
        subtitle="Şimdi bizimle iletişime geçin ve hayallerinizi gerçekleştirelim."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default About; 